export const PLANS = [
  {
    name: "Starter",
    description: "For small brands starting with GEO",
    monthlyPrice: 149,
    yearlyPrice: 1548, // $129/mo billed annually
    type: "solo",
  },
  {
    name: "Growth",
    description: "For growing content teams",
    monthlyPrice: 499,
    yearlyPrice: 4788, // $399/mo billed annually
    type: "pro",
  },
];

export const PLAN_FEATURES = {
  solo: [
    "Prompt scoring & optimization",
    "Content creation",
    "Gap analysis",
    "Gap remediation",
    "Competitor intelligence",
    "Source & citation tracking",
    "Sentiment analysis",
    "Content import",
    "Analytics dashboard",
    "25 content generations/mo",
    "10 query discoveries/mo",
  ],
  pro: [
    "Prompt scoring & optimization",
    "Content creation",
    "Gap analysis",
    "Gap remediation",
    "Competitor intelligence",
    "Source & citation tracking",
    "Sentiment analysis",
    "Content import",
    "Analytics dashboard",
    "100 content generations/mo",
    "50 query discoveries/mo",
  ],
};

/**
 * Resource limits that differentiate plans, rendered as a 2-column
 * spec grid (eyebrow label + value) inside commitment-mode surfaces.
 */
export const PLAN_RESOURCE_SUMMARY = {
  solo: [
    { key: "projects", label: "Brands", value: "1 project" },
    { key: "prompts", label: "Prompts", value: "100 / project" },
    { key: "competitors", label: "Competitors", value: "Up to 5" },
    { key: "engines", label: "AI engines", value: "2 per scan" },
    { key: "contentGens", label: "Content", value: "25 / month" },
    { key: "queryDiscovery", label: "Discoveries", value: "10 / month" },
  ],
  pro: [
    { key: "projects", label: "Brands", value: "3 projects" },
    { key: "prompts", label: "Prompts", value: "500 / project" },
    { key: "competitors", label: "Competitors", value: "Up to 20" },
    { key: "engines", label: "AI engines", value: "All 4 per scan" },
    { key: "contentGens", label: "Content", value: "100 / month" },
    { key: "queryDiscovery", label: "Discoveries", value: "50 / month" },
  ],
};
